<template>
    <!-- 胚布档案详情 -->
    <div class="rzy-page">
        <div class="rzy-top-bar">
            <el-button type="primary" @click="refreshPage()" style="" size="mini" icon="el-icon-refresh">刷新</el-button>

            <el-button type="primary" @click="previousRecord()" style="" size="mini" icon="el-icon-arrow-up">上一条
            </el-button>
            <el-button type="primary" @click="nextRecord()" style="" size="mini" icon="el-icon-arrow-down">下一条
            </el-button>

<!--            <el-button type="primary" @click="initPrint('pageDetail')" size="mini" icon="el-icon-printer">打印
            </el-button> -->

            <el-button type="success" @click="editWarehouse()" size="mini" icon="el-icon-edit">编辑</el-button>
        </div>

        <div id="pageDetail" class="wuliaoDetail">
            <el-descriptions border size="medium" column="4">
                <el-descriptions-item label="仓库编号">{{warehouseInfo.number}}</el-descriptions-item>
                <el-descriptions-item label="仓库名称">{{warehouseInfo.name}}</el-descriptions-item>
                <el-descriptions-item label="允许负库存">
                    <el-switch v-model="warehouseInfo.enableNegative"> </el-switch>
                </el-descriptions-item>
                <el-descriptions-item label="启用仓位">
                    <el-switch v-model="warehouseInfo.enablePosition"> </el-switch>
                </el-descriptions-item>

                <el-descriptions-item label="仓管员">{{warehouseInfo.contact}}</el-descriptions-item>
                <el-descriptions-item label="手机">{{warehouseInfo.phone}}</el-descriptions-item>
                <el-descriptions-item label="地址">{{warehouseInfo.address}}</el-descriptions-item>
                <!-- 占位用，别删除 -->
                <el-descriptions-item label="">{{warehouseInfo.XXXX}}</el-descriptions-item>

                <el-descriptions-item label="备注">{{warehouseInfo.remarks}}</el-descriptions-item>
            </el-descriptions>
        </div>

        <el-row :gutter="10" style="margin-top:10px" class="wuliaoPanels">
            <el-col :lg="24" :md="24" :sm="24">
                <div class="col-header">仓位</div>
                <el-table :data="warehouseInfo.positionItems" :row-style="{height: '0'}" :cell-style="{'padding':'0px'}"
                    :header-cell-style="{padding: 0}" border>
                    <el-table-column label="行" type="index" :index="indexMethod">
                    </el-table-column>
                    <el-table-column v-for="(obj,key,index) in positionItemsKeys" :key="index" :label="obj.value"
                        :width="obj.width" :prop="key" align="center" />

                    <el-table-column lable="操作">
                        <template slot-scope="data">
                            <el-button type="primary" @click="qrCodeGeneration(data.row.lineNo)" style="" size="mini"
                                icon="el-icon-refresh">
                                打印二维码</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>

        <!-- 二维码弹框 -->
        <el-dialog title="仓位 二维码" :visible.sync="qrCodeVisible" width="70%">
            <el-button type="primary" @click="initPrint('dialogDetail')" size="mini" icon="el-icon-printer">打印
            </el-button>

            <div >			
					<el-descriptions border size="medium" column="2">
						<el-descriptions-item label="仓库编号">{{warehouseInfo.number}}</el-descriptions-item>
						<el-descriptions-item label="仓库名称">{{warehouseInfo.name}}</el-descriptions-item>
					</el-descriptions>
					<el-descriptions border size="medium" column="2">
						<el-descriptions-item label="仓位编号">{{warehouseInfo.positionItems[this.g_index].number}}
						</el-descriptions-item>
						<el-descriptions-item label="仓位名称">{{warehouseInfo.positionItems[this.g_index].name}}
						</el-descriptions-item>
					</el-descriptions>

					<br /><br />
					<!-- 二维码图片 -->
					
					<div id="dialogDetail">	
					
<!-- 				打印页边距设定为 0mm 时，网页内最大元素的分辨率：794×1123
					<div style="794px;height:1123px;border:1px solid #000000;"> </div> 				
					打印页边距设定为 5mm 时，网页内最大元素的分辨率：756×1086 				
					<div style="756px;height:1086px;border:1px solid #000000;"> </div> 					
					打印页边距设定为 19.05mm 时，网页内最大元素的分辨率：649×978 
					<div style="649px;height:978px;border:1px solid #000000;"> </div> -->
					
					   <div class="A4" style="height:978px; width:649x;">	
							<!-- <div class="A4" style="height:800px; width:800px;">	 -->
							<div style="padding: 15px;border: 2px solid #000; width:330px; height: 400px;margin: auto;">						
								<div id="qrCodeUrl"></div>
								<br />
								<div style="width: 100%; ">
									<div style=" font-size: 25px; line-height: 25px;text-align: center;">
										{{warehouseInfo.name}}-{{warehouseInfo.positionItems[this.g_index].name}}
									</div>
									<div style="padding-top: 10px; font-size: 19px;line-height: 25px;text-align: center;">
										{{warehouseInfo.positionItems[this.g_index].number}}
									</div>
								</div>
						
							</div>
						</div>
					
					</div>
					
<!-- 					<el-table border>
					</el-table> -->
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import QRCode from 'qrcodejs2' //二维码生成

    export default {
        data() {
            return {
                warehouseInfo: {
                    name: '', // 名称
                    number: '', // 编号
                    enableNegative: false, //允许负库存
                    enablePosition: true, //启用仓位

                    positionItems: [], //仓位
                },

                //仓位
                positionItemsKeys: {
                    status: {
                        value: '状态',
                        width: 50
                    },
                    number: {
                        value: '仓位编码',
                        width: 150
                    },
                    name: {
                        value: '仓位名称',
                        width: 150
                    },
                    warehouseName_backup: {
                        value: '对应仓库',
                        width: 150
                    },
                    remarks: {
                        value: '备注',
                        width: 150
                    },
                },

                lastWarehouseId: 0, // 上一条/下一条 切换后，记录最新的 物料ID

                qrCodeVisible: false, // 是否显示 二维码弹框
                g_index: 0, //打印二维码时的行号。
            }
        },
        methods: {
            // 根据ID，获取 物料 信息
            getWarehouseInfo(warehouseId) {
                this.$requestBase({
                    url: 'v1/warehouse/detail',
                    method: 'get',
                    params: {
                        id: warehouseId
                    }
                }).then(res => {
                    res = res.data
                    this.warehouseInfo = res
                    this.formatResponse()
                })

            },

            //格式化 返回结果
            formatResponse() {
                //对某些字段 做 显示变换。
                for (let i = 0; i < this.warehouseInfo.positionItems.length; i++) {
                    this.warehouseInfo.positionItems[i].warehouseName_backup = this.warehouseInfo.name

                    this.warehouseInfo.positionItems[i].lineNo = i + 1 //临时保存行号
                }
            },


            // 在打印当前报表前，拼接title
            initPrint(id) {
                this.utils.printElement(id)
            },
            // 刷新
            refreshPage() {
                this.getWarehouseInfo(this.lastWarehouseId)
                this.avoidMultiPop('刷新成功。')
            },
            // 上一条记录
            previousRecord() {
                this.$requestBase({
                    url: 'v1/warehouse/prev',
                    method: 'get',
                    params: {
                        id: this.lastWarehouseId,
                        kind: 'YL', //胚布 = PB, 原料 = YL。
                    }
                }).then(res => {
                    res = res.data

                    if (res != undefined) {
                        this.warehouseInfo = res
                        this.formatResponse()

                        this.lastWarehouseId = res.id //更新工单ID
                        this.avoidMultiPop('切换下一条记录成功。')
                    } else { // null 表示数据库 到顶 或者 到底。
                        this.avoidMultiPop('没有更多数据。')
                    }
                })
            },
            // 下一条记录
            nextRecord() {
                this.$requestBase({
                    url: 'v1/warehouse/next',
                    method: 'get',
                    params: {
                        id: this.lastWarehouseId,
                        kind: 'YL', //胚布 = PB, 原料 = YL。
                    }
                }).then(res => {
                    res = res.data

                    if (res != undefined) {
                        this.warehouseInfo = res
                        this.formatResponse()

                        this.lastWarehouseId = res.id //更新工单ID
                        this.avoidMultiPop('切换下一条记录成功。')
                    } else { // null 表示数据库 到顶 或者 到底。
                        this.avoidMultiPop('没有更多数据。')
                    }
                })
            },
            //避免重复弹窗
            avoidMultiPop(message) {
                this.$Message.closeAll()
                this.$Message.success(message)
            },

            // 编辑胚布档案
            editWarehouse() {
                this.$router.push({
                    path: `../warehouseConstructionAdd`,
                    query: {
                        type: 1, //0=新建, 1=编辑.
                        warehouseId: this.$route.params.id,
                    }
                })
            },

            //给 所有 表格 自动 加行号
            indexMethod(index) {
                return index + 1;
            },

            // 二维码生成
            qrCodeGeneration(lineNo) {
                // console.log('lineNo=', lineNo)
                this.g_index = lineNo - 1
                // 二维码弹框显示
                this.qrCodeVisible = true;

                // 生成二维码
                this.$nextTick(function() {
                    document.getElementById("qrCodeUrl").innerHTML = "";
                    let qrCodeUrl = new QRCode("qrCodeUrl", {
                        width: 300,
                        height: 300,
                        text: this.warehouseInfo.positionItems[this.g_index].number, //单据编号
                        colorDark: "#409EFF",
                        colorLight: "#fff"
                    });
                });
            },

        },
        created() {
            this.getWarehouseInfo(this.$route.params.id)

            this.lastWarehouseId = this.$route.params.id //初始化时候 备份 工单ID.
        }
    }
</script>

<style lang='scss' scoped>
</style>
